import { AddAllQueuestoQueueComponent } from './add-all-queues-to-queue/add-all-queues-to-queue';
import { AllUsersQueuesComponent } from './all-users-queues/all-users-queues.component';
import { SingleUserQueuesComponent } from './single-user-queues/single-user-queues.component';
import { TodaysMessagesComponent } from './todays-messages/todays-messages.component';

export const ALL_QUEUES_COMPONENTS = [
    AllUsersQueuesComponent,
    SingleUserQueuesComponent,
    TodaysMessagesComponent,
    AddAllQueuestoQueueComponent
];

export {
    AllUsersQueuesComponent,
    SingleUserQueuesComponent,
    TodaysMessagesComponent,
    AddAllQueuestoQueueComponent
}